import { metrics, type Counter, type Histogram } from '@opentelemetry/api';

// Instruments are created lazily inside initMetrics() so that the global
// MeterProvider is already registered when getMeter() is called.

export let apiErrorCounter: Counter;
export let pageLoadDuration: Histogram;
export let httpClientRequestDuration: Histogram;

export const initMetrics = () => {
  const meter = metrics.getMeter('app-metrics');

  // ============================================================================
  // HTTP Client Request Duration (gives duration, count & sum via histogram)
  // ============================================================================

  httpClientRequestDuration = meter.createHistogram('http.client.request.duration', {
    description: 'Duration of HTTP requests',
    unit: 's'
  });

  // ============================================================================
  // API Error Counter
  // ============================================================================

  apiErrorCounter = meter.createCounter('http.client.errors', {
    description: 'Count of HTTP client errors (4xx and 5xx responses)',
    unit: '1'
  });

  // ============================================================================
  // Page Load Duration Histogram
  // ============================================================================

  pageLoadDuration = meter.createHistogram('page.load.duration', {
    description: 'Duration of page navigations from route start to page loaded',
    unit: 'ms'
  });

  // ============================================================================
  // Unhandled JS Errors Counter
  // ============================================================================

  const jsErrorCounter = meter.createCounter('app.errors.unhandled', {
    description: 'Count of unhandled JavaScript errors and rejected promises',
    unit: '1'
  });

  if (typeof window !== 'undefined') {
    window.addEventListener('error', (event) => {
      jsErrorCounter.add(1, {
        'error.type': event.error?.name || 'Error',
        'error.message': event.message,
        'page.url': window.location.pathname
      });
    });

    window.addEventListener('unhandledrejection', (event) => {
      const reason = event.reason;
      jsErrorCounter.add(1, {
        'error.type': reason?.name || 'UnhandledRejection',
        'error.message': reason?.message || String(reason),
        'page.url': window.location.pathname
      });
    });
  }
};
